import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { Wrapper } from 'hb-builder/components/common/Wrapper';
import { RendererProvider } from 'hb-builder/contexts';
import {
  useBuilderContext,
  useComponentContext,
  useComponentsContext,
  useBuilderConfigContext,
} from 'hb-builder/hooks';
import type { BuilderComponent } from 'hb-builder/types';
import { getAlignItems, getJustifyContent } from 'hb-builder/utils/attributes';
import { styles } from 'hb-react/shared/components/DesignSystem/QuillEditor/ContentEditable';

const EmailFooter: BuilderComponent = () => <div />; // never used

const RenderBuilder = () => {
  const { getBodyItem } = useBuilderContext();
  const { item } = useComponentContext();
  const { components } = useComponentsContext();
  const {
    features: { workspace: workspaceConfig },
    hivebrite: { ids },
  } = useBuilderConfigContext();
  const attributes = item?.attributes;

  const bodyItem = getBodyItem();
  const { bodyWidth, displayFooter } = bodyItem.attributes;
  const { Column, Section } = components;

  return displayFooter ? (
    <RendererProvider
      bodyWidth={bodyWidth}
      ids={ids}
      isMobilePreview={false}
      isPublic={false}
      workspaceConfig={workspaceConfig}
    >
      {/* @ts-expect-error Wrapper is not typed */}
      <Wrapper dataTestId="email-footer-component">
        <Section.Render item={item} workspaceConfig={workspaceConfig}>
          <Column.Render>
            <ContentStyled
              dangerouslySetInnerHTML={{
                __html:
                  attributes?._translations?.[attributes?._previewLanguage],
              }}
              style={{
                alignItems: getAlignItems(attributes?.verticalAlign),
                color: attributes?.textColor,
                justifyContent: getJustifyContent(attributes?.horizontalAlign),
                textAlign: attributes?.horizontalAlign,
              }}
            />
          </Column.Render>
        </Section.Render>
      </Wrapper>
    </RendererProvider>
  ) : null;
};

const Render = () => <div />;

EmailFooter.componentName = 'EmailFooter';
EmailFooter.componentType = 'section';

EmailFooter.componentLabel = __('Email Footer');

EmailFooter.canBeDoubleClicked = true;
EmailFooter.canBeDragged = false;
EmailFooter.canBeListed = false;
EmailFooter.canBeSelected = true;

EmailFooter.Render = Render;
EmailFooter.RenderBuilder = RenderBuilder;

EmailFooter.item = ({ theme }) => ({
  type: EmailFooter.componentName,
  attributes: {
    _previewLanguage: 'en',
    _translations: {},
    horizontalAlign: 'center',
    readOnly: true,
    textColor: theme?.colors.asphalt,
  },
  content: '%{Footer}',
});

export default EmailFooter;

const ContentStyled = styled(Box).attrs(() => ({
  display: 'block',
}))`
  ${styles({
    disableLinks: true,
    underlineLinks: false,
  })}
`;
